import { Modal, Form, Input, Checkbox , Select, Row, Col, Empty , message, Tooltip, Spin} from 'antd';
import { useState, useEffect } from 'react';
import { MyButton, MyText } from '../common';
import { StyledCheckbox, StyledSelect } from './ConsulationPopup/style';
import {useTranslation} from "react-i18next";
import { useDispatch,useSelector } from 'react-redux';
import { RootState, selectStore, fetchKindergartensAction, fetchCitiesListAction, fetchCreateApplicationAction } from '../../utils';
import { QuestionCircleOutlined } from "@ant-design/icons";
import { Link, useNavigate } from "react-router-dom";
import InputMask from "react-input-mask";
import { PhoneOutlined } from '@ant-design/icons';
import { ConsultSuccessIcon } from '../../assets/icon/common/header';
import { useEmbeddedNavigate } from '../../utils/context/embed';

interface ConsultationFormModalProps {
  visible: boolean;
  onOk: () => void;
  onCancel: () => void;
  selectedItem: any, 
  forSpecialist: any
}

export const ScreeningConsultationPopup: React.FC<ConsultationFormModalProps> = ({ visible, onOk, onCancel, selectedItem, forSpecialist }) => {
  const [form] = Form.useForm();
  const {t} = useTranslation("common")
  // const [isLoading, setIsLoading] = useState(false);
  const {articles: {regions: regionsState}} = useSelector(selectStore)
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);
  const { Option } = Select;
  const [loading, setLoading] = useState(true);
  const citiesList = useSelector((state: any) => state.materials?.citiesList ?? { data: null, loading: false });

  const [cities, setCities] = useState([]);
  const [selectedRegion, setSelectedRegion] = useState(null);
  const [selectedCity, setSelectedCity] = useState(null);
  const [regions, setRegions] = useState([]);
  const [error, setError] = useState(null);
  const [phone, setPhone] = useState('');
  const [kindergartens, setKindergartens] = useState<any[]>([]);
  const [searchValue, setSearchValue] = useState('');
  const [searchTimeout, setSearchTimeout] = useState<NodeJS.Timeout | null>(null);
  const [selectedOrganizationInfo, setSelectedOrganizationInfo] = useState(null);
  const [noKindergarten, setNoKindergarten] = useState(false);
  const createApplication = useSelector((state: any) => state.materials?.createApplication ?? { loading: false });

  const { profile: { userData: userDataState}}: RootState = useSelector(selectStore);
  const {articles: {kindergartens: kindergartensState}} = useSelector(selectStore)
  const dispatch = useDispatch();

  const [formData, setFormData] = useState({
    name: userDataState?.data?.first_name || '',
    phone: '',
    organizationInfo: null,
    // region: null,
    // settlement: null,
    specialist: null,
    message: '',
  });
  const navigate = useNavigate();
  const embeddedNavigate = useEmbeddedNavigate();

  const normalizePhone = (value: any) => {
    if (!value) return value;
    let normalized = value.replace(/\D/g, "");

    if (normalized.length > 12) {
      normalized = normalized.slice(0, 11);
    }
    return normalized;
  };


//   useEffect(() => {
//     const fetchRegionsData = async () => {
//         try {
//             const response = await fetchRegions();
//             setRegions(response);
//         } catch (error) {
//             console.error('Ошибка при получении регионов', error);
//         }
//     };
//     fetchRegionsData();
// }, []);

// useEffect(() => {
//   if (selectedRegion) {
//       const fetchCities = async () => {
//           try {
//               const response = await fetchRegions(selectedRegion)
//               setCities(response); 
//           } catch (error) {
//               console.error('Ошибка при получении городов', error);
//           }
//       };
//       fetchCities();
//   }
// }, [selectedRegion]);

useEffect(() => {
  if (!selectedRegion) return;
  dispatch(fetchCitiesListAction(selectedRegion));
}, [selectedRegion]);

useEffect(() => {
  if (!citiesList.success || !citiesList.data) return;
  setCities(citiesList.data?.items || []);
}, [citiesList.success, citiesList.data]);

// useEffect(() => {
//   const regionId = userDataState?.data?.region_id;
//   if (!regionId) return;

//   const fetchData = async () => {
//     try {
//       const response = await fetchKindergartensList(null, null, null, regionId);
//       if (response?.kindergartens) {
//         setKindergartens(response.kindergartens);
//       } else {
//         setKindergartens([]);
//       }
//     } catch (error) {
//       console.error("Ошибка при получении данных:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   fetchData();
// }, [userDataState?.data?.region_id]);

   const handleCancel = () => {
    form.resetFields();
    setFormData({ name: "", message: "", phone: "", organizationInfo: null, specialist: null });
    setError(null);
    onCancel();
  };

 const handleSelectedOrganizationChange = (value: any) => {
    setSelectedOrganizationInfo(value);
    setFormData((prev) => ({ ...prev, organizationInfo: value }));
  };

  const handleCancelAndNavigate = () => {
    handleCancel();
    embeddedNavigate('/profile');
  };

  useEffect(() => {
  const { phone, message, organizationInfo } = formData;
  const isValidPhone = phone.length === 18;

  const isFormComplete =
    isValidPhone &&
    message &&
    (noKindergarten || organizationInfo) &&
    userDataState?.data?.region_id;

  setIsButtonDisabled(!isFormComplete);
}, [formData, noKindergarten, userDataState]);

  const handleInputChange = (field: string, value: string | boolean) => {
    setFormData(prev => ({
      ...prev,
      [field]: value,
    }));
  };

//   const handleButtonClick = async () => {
//     setIsLoading(true);
    
//     const payload = {
//         city_id: userDataState?.data?.region_id,
//         contact_value: formData.phone,
//         problem_text: formData.message,
//         user_test_id: selectedItem?.test_id,
//         ...( !noKindergarten && { organization_id: selectedOrganizationInfo } )
//     };

//     try {
//         await fetchCreateApplication(payload);
//         form.resetFields();

//         // message.success(t("applicationSubmitted"));
//         Modal.info({
//           icon: null,
//           centered: true,
//           maskClosable: true,
//           okText: 'Закрыть',
//           width: 480,
//           okButtonProps: {
//             style: { display: 'none' },
//           },
//           content: (
//             <div style={{ textAlign: 'center' }}>
//               <ConsultSuccessIcon style={{ marginBottom: 35, marginTop: 15 }} />
//               <Row justify="center" style={{marginBottom: 16}}>
//                 <Col span={24}>
//                 <MyText
//                 color="#0A033C"
//                 size={26}
//                 weight={800}
//                 style={{ fontFamily: 'Nunito', lineHeight: '32px' , display: 'block', textAlign: 'center' }}
//               >
//                 {t("applicationSent")}
//               </MyText>
//               </Col>
//               </Row>
              
//               <MyText
//                 color="#0A033C"
//                 size={18}
//                 weight={400}
//                 style={{ fontFamily: 'Nunito', marginBottom: 6, display: 'block' , textAlign: 'center' , lineHeight: '32px' }}
//               >
//                 {t("specialistContact")}
//               </MyText>

//               <MyButton
//                 color="orange"
//                 type="primary"
//                 onClick={() => Modal.destroyAll()}
//                 style={{ margin: '0 auto', display: 'block' }}
//               >
//                 {t("close")}
//               </MyButton>
//             </div>
//           ),
//         });
//         setIsLoading(false);
//         onCancel();
//     } catch (error) {
//         console.error('Ошибка при отправке заявки', error);
//         setError(error?.response?.data?.errors);
//         setIsLoading(false);
//     } finally {
//         setIsLoading(false);
//     }
// };

const handleButtonClick = () => {
  dispatch(fetchCreateApplicationAction({
    city_id: userDataState?.data?.region_id,
    contact_value: formData.phone,
    problem_text: formData.message,
    user_test_id: selectedItem?.test_id,
    ...(!noKindergarten && { organization_id: selectedOrganizationInfo }),
  }));
};

useEffect(() => {
  if (!createApplication.success) return;
  form.resetFields();
   Modal.info({
          icon: null,
          centered: true,
          maskClosable: true,
          okText: 'Закрыть',
          width: 480,
          okButtonProps: {
            style: { display: 'none' },
          },
          content: (
            <div style={{ textAlign: 'center' }}>
              <ConsultSuccessIcon style={{ marginBottom: 35, marginTop: 15 }} />
              <Row justify="center" style={{marginBottom: 16}}>
                <Col span={24}>
                <MyText
                color="#0A033C"
                size={26}
                weight={800}
                style={{ fontFamily: 'Nunito', lineHeight: '32px' , display: 'block', textAlign: 'center' }}
              >
                {t("applicationSent")}
              </MyText>
              </Col>
              </Row>
              
              <MyText
                color="#0A033C"
                size={18}
                weight={400}
                style={{ fontFamily: 'Nunito', marginBottom: 6, display: 'block' , textAlign: 'center' , lineHeight: '32px' }}
              >
                {t("specialistContact")}
              </MyText>

              <MyButton
                color="orange"
                type="primary"
                onClick={() => Modal.destroyAll()}
                style={{ margin: '0 auto', display: 'block' }}
              >
                {t("close")}
              </MyButton>
            </div>
          ),
        });
  onCancel();
}, [createApplication.success]);

useEffect(() => {
  if (!createApplication.failed) return;
  setError(createApplication.data?.errors);
}, [createApplication.failed]);

const isLoading = createApplication.loading;

// const handleSearch = (value: string) => {
//     setSearchValue(value);
//     if (searchTimeout) clearTimeout(searchTimeout);

//     const timeout = setTimeout(() => {
//       const regionId = userDataState?.data?.region_id;
//       if (!regionId) return;

//       fetchKindergartensList(null, null, value, regionId)
//         .then(response => setKindergartens(response?.kindergartens || []))
//         .catch(err => {
//           console.error("Ошибка при поиске:", err);
//           setKindergartens([]);
//         });
//     }, 500); 

//     setSearchTimeout(timeout);
//   };

  const handleSearch = (value: string) => {
      setSearchValue(value);
      if (searchTimeout) clearTimeout(searchTimeout);
  
      const timeout = setTimeout(() => {
        const regionId = userDataState?.data?.region_id;
        if (!regionId) return;
  
        dispatch(fetchKindergartensAction({
          region_id: regionId,
          search: value,
        } as any));
      }, 500);
  
      setSearchTimeout(timeout);
    };


  return (
    <Modal
      open={visible}
      onOk={onOk}
      onCancel={onCancel}
      footer={null}
      centered
      width={559}
    >
      <MyText color='#0A033C' size={32} weight={800} style={{ fontFamily: 'Nunito' }}>
      {`${t("getConsultation")}`}
      </MyText>
      <Form form={form} layout="vertical" name="consultationForm">
        <Col style={{marginTop: 25, marginBottom: 15}}>
                {userDataState?.data?.last_name && userDataState?.data?.first_name && (
                    <>
                      <MyText color='#0A033C' size={18} weight={800} style={{ fontFamily: 'Nunito', marginRight: 5 }}>
                      {userDataState.data.last_name} {userDataState.data.first_name}
                      </MyText>
                      <Tooltip title={t("editFullName")}>
                        <QuestionCircleOutlined
                          style={{ color: '#A3AED0', fontSize: 18, cursor: 'pointer', marginRight: 5 }}
                          onClick={handleCancelAndNavigate}
                        />
                      </Tooltip>
                    </>
                  )}
                  <MyText color='#0A033C' size={18} weight={600} style={{ fontFamily: 'Nunito', lineHeight: "32px" }}>
                  {/* {t("specialist")} */}
                 {t("consultText")}
                  </MyText>
                </Col>
        <Form.Item style={{ marginBottom: 5 }}>
          <MyText color='#0A033C' weight={800} style={{ fontFamily: 'Nunito' }}>
          {`${t("phone")}`}
          </MyText>
        </Form.Item>
        
        <Form.Item
          name="phone"
          style={{ marginBottom: 5 }}
          rules={[{ required: true, message: t("pleaseEnterPhoneNumber") }]}
        >

          <InputMask
              mask="+7 (799) 999-99-99"
              value={phone}
              onChange={(e) => {
                const rawValue = e.target.value.replace(/\D/g, "").slice(1, 11);
                const formattedPhone = `+7 (${rawValue.slice(0, 3)}) ${rawValue.slice(3, 6)}-${rawValue.slice(6, 8)}-${rawValue.slice(8, 10)}`;
                setPhone(formattedPhone);

                setFormData((prev) => ({ ...prev, phone: formattedPhone }));
              }}
              maskChar=""
            >
                        {(inputProps) => (
                          <Input
                            {...inputProps}
                            name="phone"
                            prefix={<PhoneOutlined style={{ color: "#969BAB", marginRight: 8 }} />}
                            placeholder="+7 (777) 777-77-77"
                          />
                        )}
                      </InputMask>
        </Form.Item>
        <Form.Item style={{ marginBottom: 5, marginTop: 15 }}>
          <MyText color='#0A033C' weight={800} style={{ fontFamily: 'Nunito' }}>
          {t("preschoolInfo")}
          </MyText>
        </Form.Item>
        <Form.Item
          name="organizationInfo"
          style={{ marginBottom: 5 }}
          rules={[{ required: true, message: t("selectFromList") }]}
        >
            <StyledSelect
              showSearch
              placeholder={t("selectFromList")}
              style={{ width: '100%', height: 52 }}
              value={selectedOrganizationInfo}
              onChange={handleSelectedOrganizationChange}
              onSearch={handleSearch}
              notFoundContent={loading ? <Spin size="small" /> : <Empty imageStyle={{ height: 80 }} description={t("noData")} />}
              disabled={noKindergarten}
              filterOption={false}
            >
                        {kindergartensState?.data?.kindergartens && kindergartensState?.data?.kindergartens.map((specialist) => (
                              <Option key={specialist.id} value={specialist.id}>
                                  {specialist.name}
                              </Option>
                          ))}
           
                      </StyledSelect>
        </Form.Item>
        <Form.Item style={{ marginBottom: 6 }}>
          <Checkbox checked={noKindergarten} onChange={(e) => setNoKindergarten(e.target.checked)}>
            <MyText color='#0A033C' weight={800} style={{ fontFamily: 'Nunito' }}>
              {t("myChildDoesNotAttend")}
            </MyText>
          </Checkbox>
        </Form.Item>
        {/* <Form.Item style={{ marginBottom: 5, marginTop: 15 }}>
          <MyText color='#0A033C' weight={800} style={{ fontFamily: 'Nunito' }}>
          {t("region")}
          </MyText>
        </Form.Item>
        <Form.Item
          name="region"
          style={{ marginBottom: 5 }}
          rules={[{ required: true, message: t("pleaseEnterYourName") }]}
        >
          <StyledSelect
                          placeholder={t("selectFromList")}
                          style={{ width: '100%',marginTop: 6, height: 52 }}
                          value={selectedRegion}
                          onChange={handleRegionChange}
                      >
                        {regionsState?.data?.items && regionsState?.data?.items.map((region) => (
                              <Option key={region.id} value={region.id}>
                                  {region.name}
                              </Option>
                          ))}
           
                      </StyledSelect>
        </Form.Item> */}

        {/* <Form.Item style={{ marginBottom: 5, marginTop: 15 }}>
          <MyText color='#0A033C' weight={800} style={{ fontFamily: 'Nunito' }}>
          {t("settlement")}
          </MyText>
        </Form.Item>
        <Form.Item
          name="settlement"
          style={{ marginBottom: 5 }}
          rules={[{ required: true, message: t("pleaseEnterYourName") }]}
        >
         <StyledSelect
                         placeholder={t("selectFromList")}
                         style={{ width: '100%', marginTop: 6, height: 52 }}
                         value={selectedCity}
                        //  onChange={(value) => setSelectedCity(value)}
                        onChange={handleCityChange}

                     >
                         {cities.map((city) => (
                             <Option key={city.id} value={city.id} style={{ fontWeight: city.is_big === 1 ? 'bold' : 'normal' }}>
                                 {city.name}
                             </Option>
                         ))}
                     </StyledSelect>
        </Form.Item> */}

        <Form.Item style={{ marginBottom: 5 }}>
          <MyText color='#0A033C' weight={800} style={{ fontFamily: 'Nunito' }}>
          {`${t("text")}`}
          </MyText>
        </Form.Item>
        
        <Form.Item
          name="message"
          style={{ marginBottom: 5 }}
          rules={[{ required: true, message:  t("pleaseDescribeYourProblem") }]}
          validateStatus={error?.problem_text ? "error" : ""}
          help={error?.problem_text}
        >
          <Input.TextArea
            rows={4}
            placeholder={`${t("describeYourIssue")}`}
            style={{
              backgroundColor: 'rgba(244, 245, 247, 1)',
              height: 127,
              resize: 'none',
            }}
            onChange={(e) => handleInputChange('message', e.target.value)}
          />
        </Form.Item>
        <Col span={24}>
        <MyText color='rgba(76, 76, 77, 1)' weight={400} style={{ fontFamily: 'Nunito' }}>
        {`${t("consultationNote")}`}
          </MyText>
        </Col>
          <Row style={{marginTop: 30}}>
          <Col span={24} >
        <MyText color='#0A033C' weight={800} style={{ fontFamily: 'Nunito' }}>
          {`${t("testType")}`}
          </MyText>
          <MyText color='rgba(76, 76, 77, 1)' weight={600} style={{ fontFamily: 'Nunito', marginLeft: 6 }}>
          {selectedItem?.list?.name}
          </MyText>
        </Col>
            <Col span={24}>
            <MyText color='#0A033C' weight={800} style={{ fontFamily: 'Nunito' }}>
            {`${t("childName")}`}
            </MyText>
            <MyText color='rgba(76, 76, 77, 1)' weight={600} style={{ fontFamily: 'Nunito', marginLeft: 6 }}>
          {selectedItem?.name}
          </MyText>
            </Col>
            <Col span={24}>
            <MyText color='#0A033C' weight={800} style={{ fontFamily: 'Nunito' }}>
          {`${t("testDate")}`}
          </MyText>
          <MyText color='rgba(76, 76, 77, 1)' weight={600} style={{ fontFamily: 'Nunito', marginLeft: 6 }}>
          {selectedItem?.time_at}
          </MyText>
            </Col>
          </Row>
        <Form.Item style={{ textAlign: 'center', marginBottom: 8, marginTop: 30 }}>
          <MyButton
            color='orange'
            type='primary'
            disabled={isButtonDisabled}
            onClick={handleButtonClick}
            loading={isLoading}
          >
            {`${t("send")}`}
          </MyButton>
        </Form.Item>
        
      </Form>
    </Modal>
  );
};
